import React, {useState} from 'react';
import styled from 'styled-components';

import { ButtonRow, ModalContainer, Overlay, Title } from './CommonModal';
import ActionButton from '../buttons/ActionButton';
import EventFormInput from '../EventForm/EventFormInput';
import useInviteeUuidStorage from '../../hooks/useInviteeUuidStorage';
import { IUEvent } from '../../lib/event';

import appStoreSvg from 'Common/src/assets/app_store.svg';
import sunshinePhotosPng from 'Common/src/assets/ShineIcon.svg';
import { DeviceQueries } from 'Common/src/components/styled';

const PhotoPromoModal = ({ event, close, isAdded, onPhoneCodeVerify }: { event: IUEvent, close: () => void, isAdded: boolean, onPhoneCodeVerify: () => void }) => {
  const [phoneNum, setPhoneNum] = useState<string>('')
  const { setPhone } = useInviteeUuidStorage();

  const onPhoneChange = (phoneNumber: string) => {
    setPhoneNum(phoneNumber)
    //TODO: (bella) add a check for valid us phone number
    //add phone number to local storage
    setPhone(phoneNumber)
  };

  return <Overlay>
    <ModalContainer $wide={true} $maxWidth="600px">
      <CloseButton onClick={close}>
        x
      </CloseButton>
      <Title>Share your photos!</Title>
      {
        isAdded ? <div>
          You’ve been added to the album for {event.title}.  Download the Shine app to make sharing event photos easy and automatic.
        </div> : <>
          <div>
            You’ve been added to the album for {event.title}.
            Confirm your phone number now to automatically be subscribed to the album for the event.
          </div>
          <EventFormInput
              label="Phone"
              value={phoneNum}
              onChange={onPhoneChange}
              color={'var(--shine-text-color)'}
          />
          <ActionButton onClick={onPhoneCodeVerify}>Join Album</ActionButton>
        </>
      }
      <ContainerContainer>
      <AppContainer>
        <IconA href="https://apps.apple.com/us/app/sunshine-photos/id6469663904?itscg=30200&amp;itsct=apps_box_appicon"
               target="_blank">
          <IconImg src={sunshinePhotosPng} alt="Shine"/>
        </IconA>

        <AppDetails>
          <AppTitle>
            Shine
            <AppBadge>4+</AppBadge>
          </AppTitle>

          <AppSubtitle>
            Share event photos seamlessly
          </AppSubtitle>

          <AppIdentity>
            Sunshine Products, Inc.
          </AppIdentity>

          <AppStoreA
            href="https://apps.apple.com/us/app/sunshine-photos/id6469663904?itsct=apps_box_badge&amp;itscg=30200"
            target="_blank"
          >
            <AppStoreImg src={appStoreSvg} alt="Download on the App Store"/>
          </AppStoreA>
        </AppDetails>
      </AppContainer>
      </ContainerContainer>

      <ButtonRow>
        <ActionButton type="button" onClick={close} outline={true}>Okay</ActionButton>
      </ButtonRow>
    </ModalContainer>
  </Overlay>;
};

const AppContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
  font-family: "SF Pro Display", "SF Pro Icons", "Apple WebExp Icons Custom", "Helvetica Neue", Helvetica, Arial, sans-serif;

`;

const ContainerContainer = styled.div`
  display: flex;
  justify-content: center;
  @media (${DeviceQueries.mobile}) {
    transform: scale(0.7);
  }
`

const AppDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 10px;
`;

const IconA = styled.a`
  width: 170px;
  height: 170px;
  border-radius: 22%;
  overflow: hidden;
  display: inline-block;
  vertical-align: middle;
  min-width: 170px;
`;

const AppTitle = styled.div`
  font-size: 18px;
  line-height: 1.25;
  font-weight: 700;
  letter-spacing: .023em;
  padding-left: 5px;
`;

const AppBadge = styled.span`
  margin: 0 0 2px 3px;
  padding-bottom: 0;
  display: inline-block;
  font-size: 8px;
  letter-spacing: .04em;
  vertical-align: middle;
  line-height: 1.3;
  font-weight: 700;
  border: 1px solid #636366;
  border-radius: 3px;
  color: #636366;
  text-align: center;
  white-space: nowrap;
  padding-left: 3px;
  padding-right: 3px;
`;

const AppSubtitle = styled.div`
  font-size: 16px;
  line-height: 1.22226;
  font-weight: 400;
  letter-spacing: .027em;
  opacity: .8;
  padding-left: 5px;
`;

const AppIdentity = styled.div`
  font-size: 16px;
  line-height: 1.22226;
  font-weight: 400;
  letter-spacing: .027em;
  margin: 2px 0 5px;
  padding-left: 5px;
`;

const IconImg = styled.img`
  width: 170px;
  height: 170px;
  border-radius: 22%;
  overflow: hidden;
  display: inline-block;
  vertical-align: middle;
  min-width: 170px;
`;

const AppStoreA = styled.a`
  display: inline-block;
  overflow: hidden;
  border-radius: 13px;
  width: 250px;
  height: 83px;
`;

const AppStoreImg = styled.img`
  border-radius: 13px;
  width: 250px;
  height: 83px;
`;

const CloseButton = styled.button`
  position: absolute; // Position it relative to the modal
  top: 10px; // Adjust top and right as needed
  right: 10px;
  background: transparent;
  border: none;
  cursor: pointer;
  color: var(--shine-text-color);
  font-size: 18px;
`;

export default PhotoPromoModal;
